// katalogCache.ts — Stammdaten-Kataloge (Anreden, Titel, Rechtsformen …) einmal
// je Sitzung laden statt je Bauteil.
//
// Befund 28.09.2026: Beim Öffnen einer Kontaktakte gingen `contactsalutation`
// vier- und `contact-legal-form` viermal raus — jede Karte der Maske lud ihren
// Katalog selbst. Hier teilt sich jeder Aufrufer DENSELBEN Promise; nach
// `GUELTIG_MS` wird neu geladen, ein Fehlschlag wird nicht gemerkt. Wer einen
// Katalog ändert (Einstellungen), ruft `katalogVergessen(pfad)`.

import { apiUrl } from "./api";

const GUELTIG_MS = 5 * 60 * 1000;

const eintraege = new Map<string, { promise: Promise<unknown>; seit: number }>();

/** Katalog unter `pfad` (z. B. "contactsalutation") als JSON — geteilt und gecacht. */
export function katalogLaden<T = unknown>(pfad: string): Promise<T> {
  const jetzt = Date.now();
  const alt = eintraege.get(pfad);
  if (alt && jetzt - alt.seit < GUELTIG_MS) return alt.promise as Promise<T>;
  const promise = fetch(apiUrl(pfad)).then((r) => {
    if (!r.ok) throw new Error(`Katalog ${pfad}: HTTP ${r.status}`);
    return r.json();
  });
  eintraege.set(pfad, { promise, seit: jetzt });
  // Einen Fehlschlag nicht behalten — der nächste Aufrufer versucht es neu.
  promise.catch(() => {
    if (eintraege.get(pfad)?.promise === promise) eintraege.delete(pfad);
  });
  return promise as Promise<T>;
}

/** Cache verwerfen — für einen Pfad oder (ohne Argument) ganz. */
export function katalogVergessen(pfad?: string): void {
  if (pfad == null) eintraege.clear();
  else eintraege.delete(pfad);
}
